<template>
  <div class="util-latest-list">
    <div class="util-card" v-for="(row,i) in listdata" :key="i">
      <div class="util-card-date">
        <strong>{{ dayjs(row.date).format("D") }}</strong>
        <span>{{ dayjs(row.date).format("MMM") }}</span>
        <span>{{ dayjs(row.date).format("YYYY") }}</span>
      </div>
      <div class="util-card-detail ucdl">
        <div class="ucdl-item">
          <span>Meteran 1</span>
          <p>
            <strong>{{ nom(row.sdp_lapis_kwh) }}</strong> Kwh
          </p>
        </div>
        <div class="ucdl-item">
          <span>Meteran 2</span>
          <p>
            <strong>{{ nom(row.sdp_chesse_kwh) }}</strong> Kwh
          </p>
        </div>
        
        <div class="ucdl-item">
          <span>Meteran 3</span>
          <p>
            <strong>{{ nom(row.sdp_office_kwh) }}</strong> Kwh
          </p>
        </div>
        <div class="ucdl-item">
          <span>Total</span>
          <p class="pgreen"> 
            <strong>{{ nom(row.total_pemakaian_gwh) }}</strong> Kwh
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Vue from "vue";
import dayjs from "dayjs";
import { Prop } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import { nom  } from "@/api/api";
@Component({})
export default class UtilitiesListrikList extends Vue {
  @Prop () listdata;
  dayjs = dayjs
  nom = nom
}
</script>
